import localization from "../../../../config/localization";
import common from "../../../../utils/common";
import { formatTimestampToLocalDateTime } from "../../../../utils/dateTimeHelper";
import { BetHistory } from "../../models/response/sportsHistorySummaryResponse";

export default function SingleBet({ betDetails }: { betDetails: BetHistory }) {
  return (
    <div className="grid gap-y-2">
      <div>
        <span>{localization.betid}</span>
        <span className="float-right text-white">
          {betDetails.betslipId}
          <img
            src={"/icons/ic-copy.svg"}
            alt="Copy"
            className="size-4 inline ml-2 cursor-pointer"
            onClick={() =>
              common.copyIdToClipboard(
                betDetails.betslipId!,
                localization.betslipid_success_copied,
              )
            }
          />
        </span>
      </div>

      {betDetails.betHistorydetails &&
        betDetails.betHistorydetails?.length > 0 &&
        betDetails.betHistorydetails.map((detail) => {
          return (
            <div className="grid gap-y-2">
              <div>
                <span>{localization.league_name}</span>
                <span className="float-right text-white">
                  {detail.tournamentName}
                </span>
              </div>

              <div>
                <span>{localization.event_date}</span>
                <span className="float-right text-white">
                  {formatTimestampToLocalDateTime(detail.scheduled)}
                </span>
              </div>

              <div>
                <span>{localization.odds}</span>
                <span className="float-right text-white">
                  {detail.odds.toFixed(2)}
                </span>
              </div>

              <div>
                <span>{localization.bet}</span>
                <span className="float-right text-white">
                  {detail.bet.toFixed(2)}
                </span>
              </div>
            </div>
          );
        })}
    </div>
  );
}
